// React Required
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ChakraProvider } from '@chakra-ui/react';

// Create Import File
import './index.scss';

// Import theme
import theme from './theme/theme';

// Common Layout
// import Layout from "./component/common/App";

import PageScrollTop from './component/PageScrollTop';

// Home layout
import Home from './home/Home';

// Element Layout
import AboutMuseum from "./elements/AboutMuseum";
import Contact from "./elements/Contact";
import error404 from "./elements/error404";
import ExhibitFloor1 from "./elements/ExhibitFloor1";
import ExhibitFloor2 from "./elements/ExhibitFloor2";
import ExhibitionsAndActivities from "./elements/ExhibitionsAndActivities";
import Gallery from "./elements/Gallery";
import MuseumHistory from "./elements/MuseumHistory";
import SingthaHistory from "./elements/SingthaHistory";
import NearbyPlaces from "./elements/NearbyPlaces";

// Modern Components
import ModernHomePage from './pages/ModernHomePage';
import ModernAboutUs from './pages/ModernAboutUs';
import ModernContactUs from './pages/ModernContactUs';
import ModernExhibitions from './pages/ModernExhibitions';
import ModernGallery from './pages/ModernGallery';
import ModernLayout from './component/layout/ModernLayout';
import DemoPage from './pages/DemoPage';

import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import GoogleMap from './blocks/GoogleMap';

class Root extends Component {
    render() {
        return (
            <ChakraProvider theme={theme}>
                <BrowserRouter basename={'/'}>
                    <PageScrollTop>
                        <Switch>
                            {/* Original Routes */}
                            <Route exact path={`${process.env.PUBLIC_URL}/`} component={Home} />

                            {/* Element Layout */}
                            <Route exact path={`${process.env.PUBLIC_URL}/contact`} component={Contact} />
                            <Route exact path={`${process.env.PUBLIC_URL}/about-us`} component={AboutMuseum} />
                            <Route exact path={`${process.env.PUBLIC_URL}/museum-history`} component={MuseumHistory} />
                            <Route exact path={`${process.env.PUBLIC_URL}/singhatha-history`} component={SingthaHistory} />

                            <Route exact path={`${process.env.PUBLIC_URL}/exhibitions`} component={ExhibitionsAndActivities} />
                            <Route exact path={`${process.env.PUBLIC_URL}/exhibition-floor-1`} component={ExhibitFloor1} />
                            <Route exact path={`${process.env.PUBLIC_URL}/exhibition-floor-2`} component={ExhibitFloor2} />
                            
                            {/* GoogleMap Routes - Multiple paths to prevent redirect issues */}
                            <Route exact path={`${process.env.PUBLIC_URL}/googlemap`} component={GoogleMap} />
                            <Route exact path={`${process.env.PUBLIC_URL}/nearby-places`} component={GoogleMap} />
                            <Route exact path={`${process.env.PUBLIC_URL}/places`} component={GoogleMap} />
                            
                            {/* New Nearby Places Route */}
                            <Route exact path={`${process.env.PUBLIC_URL}/nearby-attractions`} component={NearbyPlaces} />
                            
                            <Route exact path={`${process.env.PUBLIC_URL}/gallery`} component={Gallery} />

                            {/* Modern Redesign Routes */}
                            <Route exact path={`${process.env.PUBLIC_URL}/modern`} component={ModernLayout}>
                                <ModernHomePage />
                            </Route>
                            <Route exact path={`${process.env.PUBLIC_URL}/modern/about`} component={ModernLayout}>
                                <ModernAboutUs />
                            </Route>
                            <Route exact path={`${process.env.PUBLIC_URL}/modern/contact`} component={ModernLayout}>
                                <ModernContactUs />
                            </Route>
                            <Route exact path={`${process.env.PUBLIC_URL}/modern/exhibitions`} component={ModernLayout}>
                                <ModernExhibitions />
                            </Route>
                            <Route exact path={`${process.env.PUBLIC_URL}/modern/gallery`} component={ModernLayout}>
                                <ModernGallery />
                            </Route>
                            <Route exact path={`${process.env.PUBLIC_URL}/demo`} component={DemoPage} />

                            {/* Catch all routes */}
                            <Route path={`${process.env.PUBLIC_URL}/404`} component={error404} />
                            <Route component={error404} />

                        </Switch>
                    </PageScrollTop>
                </BrowserRouter>
            </ChakraProvider>
        )
    }
}

ReactDOM.render(<Root />, document.getElementById('root'));
serviceWorker.register();